import React from "react";
import styled from "styled-components";
import profileImg from "../../assets/headshot.jpg";
import { ScreenSize, useScreenSize } from "../../contexts/ScreenSizeContext";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CircleImage = styled.img<{ $screenSize: ScreenSize }>`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 3px solid #333;
  object-fit: cover;
  margin-top: ${({ $screenSize }) =>
    $screenSize === "mobile" ? "75px" : "0px"};
  margin-bottom: 10px;
`;

// Styled text line
const Text = styled.p`
  margin: 5px 0;
  font-size: 1rem;
  font-weight: 400;
  color: ${({ theme }) => (theme ? theme.fontColor : "#ffffff")};
`;

// Row container for social icons
const SocialIconsRow = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 15px;
`;

// Styled social icon image
const SocialIcon = styled.div`
  cursor: pointer;
`;

const ProfileCard: React.FC = () => {
  const { screenSize } = useScreenSize();
  return (
    <Container>
      <CircleImage src={profileImg} alt="Profile" $screenSize={screenSize} />
      <Text>James Scott</Text>
      <Text>Software Engineer</Text>
      {/* <Text>Tokyo</Text> */}
      <SocialIconsRow>
        {/* LinkedIn */}
        <SocialIcon
          onClick={() =>
            window.open(
              "https://www.linkedin.com/in/james-scott-511136173/",
              "_blank"
            )
          }
        >
          <svg height="25" version="1.1" viewBox="0 0 512 512" width="25">
            <path
              fill="white"
              d="M449.446,0c34.525,0 62.554,28.03 62.554,62.554l0,386.892c0,34.524 -28.03,62.554 -62.554,62.554l-386.892,0c-34.524,0 -62.554,-28.03 -62.554,-62.554l0,-386.892c0,-34.524 28.029,-62.554 62.554,-62.554l386.892,0Zm-288.985,423.278l0,-225.717l-75.04,0l0,225.717l75.04,0Zm270.539,0l0,-129.439c0,-69.333 -37.018,-101.586 -86.381,-101.586c-39.804,0 -57.634,21.891 -67.617,37.266l0,-31.958l-75.021,0c0.995,21.181 0,225.717 0,225.717l75.02,0l0,-126.056c0,-6.748 0.486,-13.492 2.474,-18.315c5.414,-13.475 17.767,-27.434 38.494,-27.434c27.135,0 38.007,20.707 38.007,51.037l0,120.768l75.024,0Zm-307.552,-334.556c-25.674,0 -42.448,16.879 -42.448,39.002c0,21.658 16.264,39.002 41.455,39.002l0.484,0c26.165,0 42.452,-17.344 42.452,-39.002c-0.485,-22.092 -16.241,-38.954 -41.943,-39.002Z"
            />
          </svg>
        </SocialIcon>
        {/* Github */}
        <SocialIcon
          onClick={() =>
            window.open("https://github.com/JamesScottCode", "_blank")
          }
        >
          <svg
            enableBackground="new 0 0 32 32"
            height="25"
            id="Layer_1"
            version="1.0"
            viewBox="0 0 32 32"
            width="25"
          >
            <path
              clipRule="evenodd"
              d="M16.003,0C7.17,0,0.008,7.162,0.008,15.997  c0,7.067,4.582,13.063,10.94,15.179c0.8,0.146,1.052-0.328,1.052-0.752c0-0.38,0.008-1.442,0-2.777  c-4.449,0.967-5.371-2.107-5.371-2.107c-0.727-1.848-1.775-2.34-1.775-2.34c-1.452-0.992,0.109-0.973,0.109-0.973  c1.605,0.113,2.451,1.649,2.451,1.649c1.427,2.443,3.743,1.737,4.654,1.329c0.146-1.034,0.56-1.739,1.017-2.139  c-3.552-0.404-7.286-1.776-7.286-7.906c0-1.747,0.623-3.174,1.646-4.292C7.28,10.464,6.73,8.837,7.602,6.634  c0,0,1.343-0.43,4.398,1.641c1.276-0.355,2.645-0.532,4.005-0.538c1.359,0.006,2.727,0.183,4.005,0.538  c3.055-2.07,4.396-1.641,4.396-1.641c0.872,2.203,0.323,3.83,0.159,4.234c1.023,1.118,1.644,2.545,1.644,4.292  c0,6.146-3.74,7.498-7.304,7.893C19.479,23.548,20,24.508,20,26c0,2,0,3.902,0,4.428c0,0.428,0.258,0.901,1.07,0.746  C27.422,29.055,32,23.062,32,15.997C32,7.162,24.838,0,16.003,0z"
              fill="white"
            />
          </svg>
        </SocialIcon>
        {/* Phone */}
        {/* <Tooltip text="+1 501-333-5301">
          <SocialIcon>
            <svg height="25" version="1.1" viewBox="0 0 512 512" width="25">
              <path
                fill="white"
                d="M449.446,0c34.525,0 62.554,28.03 62.554,62.554l0,386.892c0,34.524 -28.03,62.554 -62.554,62.554l-386.892,0c-34.524,0 -62.554,-28.03 -62.554,-62.554l0,-386.892c0,-34.524 28.029,-62.554 62.554,-62.554l386.892,0Zm-58.673,127.703c-33.842,-33.881 -78.847,-52.548 -126.798,-52.568c-98.799,0 -179.21,80.405 -179.249,179.234c-0.013,31.593 8.241,62.428 23.927,89.612l-25.429,92.884l95.021,-24.925c26.181,14.28 55.659,21.807 85.658,21.816l0.074,0c98.789,0 179.206,-80.413 179.247,-179.243c0.018,-47.895 -18.61,-92.93 -52.451,-126.81Zm-126.797,275.782l-0.06,0c-26.734,-0.01 -52.954,-7.193 -75.828,-20.767l-5.441,-3.229l-56.386,14.792l15.05,-54.977l-3.542,-5.637c-14.913,-23.72 -22.791,-51.136 -22.779,-79.287c0.033,-82.142 66.867,-148.971 149.046,-148.971c39.793,0.014 77.199,15.531 105.329,43.692c28.128,28.16 43.609,65.592 43.594,105.4c-0.034,82.149 -66.866,148.983 -148.983,148.984Zm81.721,-111.581c-4.479,-2.242 -26.499,-13.075 -30.604,-14.571c-4.105,-1.495 -7.091,-2.241 -10.077,2.241c-2.986,4.483 -11.569,14.572 -14.182,17.562c-2.612,2.988 -5.225,3.364 -9.703,1.12c-4.479,-2.241 -18.91,-6.97 -36.017,-22.23c-13.314,-11.876 -22.304,-26.542 -24.916,-31.026c-2.612,-4.484 -0.279,-6.908 1.963,-9.14c2.016,-2.007 4.48,-5.232 6.719,-7.847c2.24,-2.615 2.986,-4.484 4.479,-7.472c1.493,-2.99 0.747,-5.604 -0.374,-7.846c-1.119,-2.241 -10.077,-24.288 -13.809,-33.256c-3.635,-8.733 -7.327,-7.55 -10.077,-7.688c-2.609,-0.13 -5.598,-0.158 -8.583,-0.158c-2.986,0 -7.839,1.121 -11.944,5.604c-4.105,4.484 -15.675,15.32 -15.675,37.364c0,22.046 16.048,43.342 18.287,46.332c2.24,2.99 31.582,48.227 76.511,67.627c10.685,4.615 19.028,7.371 25.533,9.434c10.728,3.41 20.492,2.929 28.209,1.775c8.605,-1.285 26.499,-10.833 30.231,-21.295c3.732,-10.464 3.732,-19.431 2.612,-21.298c-1.119,-1.869 -4.105,-2.99 -8.583,-5.232Z"
              />
            </svg>
          </SocialIcon>
        </Tooltip> */}
      </SocialIconsRow>
    </Container>
  );
};

export default ProfileCard;
